import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
// Avatar,
  Box, ButtonBase, Hidden, Menu, MenuItem, Typography
} from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import AdminSignInAs from 'src/containers/AdminSignInAs';
import helpers from 'src/helpers';
import { PERMISSIONS_SYSTEM_CODE } from 'src/constants/permissions';

const useStyles = makeStyles()((theme) => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1)
  },
  popover: {
    width: 200
  }
}));

function Account({ logout }) {
  const { classes } = useStyles();
  const ref = useRef(null);
  const { user } = useSelector((state) => state.account);
  const [isOpen, setOpen] = useState(false);
  const [isSignInAsOpen, setSignInAsOpen] = useState(false);
  // CON-1963. Admin-role accounts already get the forced Sign-In As dialog
  // (DashboardLayout); every other SIGN_IN_AS holder opens it from here.
  const showSignInAs = !helpers.isUserAdmin(user)
    && helpers.permissions.doesUserHavePermission(
      PERMISSIONS_SYSTEM_CODE.SIGN_IN_AS,
      user?.userRole?.permissions,
    );
  // const isPageBlocked = helpers.isPageBlocked(user);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    logout(handleClose);
  };

  const handleOpenSignInAs = () => {
    handleClose();
    setSignInAsOpen(true);
  };

  return (
    <>
      <Box display="flex" alignItems="center" component={ButtonBase} onClick={handleOpen} ref={ref}>
        {/* <Avatar
      alt="User"
      className={classes.avatar}
      src={user.avatar}
    /> */}
        <Hidden mdDown>
          <Typography variant="h6" color="inherit">
            {`${user?.firstName || ''} ${user?.lastName || ''}`}
          </Typography>
        </Hidden>
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        anchorEl={ref.current}
        open={isOpen}
      >
        {/* <MenuItem
      component={RouterLink}
      to="/app/social/profile"
    >
      Profile
    </MenuItem> */}
        <MenuItem
          component={RouterLink}
          to="/app/account"
          onClick={handleClose}
        >
          Account
        </MenuItem>
        {showSignInAs && (
          <MenuItem
            onClick={handleOpenSignInAs}
          >
            Sign In As
          </MenuItem>
        )}
        <MenuItem
          onClick={handleLogout}
        >
          Logout
        </MenuItem>
      </Menu>
      {showSignInAs && isSignInAsOpen && (
        <AdminSignInAs
          logout={logout}
          open
          onCancel={() => setSignInAsOpen(false)}
        />
      )}
    </>
  );
}

Account.propTypes = {
  logout: PropTypes.func.isRequired,
};

export default Account;
